import React, { useState, useEffect } from 'react';
import { updatePolicy } from '../utils/api';
import './_Modal.css';

const EditPolicyModal = ({ policy, onClose, onPolicyUpdated }) => {
    const [name, setName] = useState('');
    const [text, setText] = useState('');

    useEffect(() => {
        if (policy) {
            setName(policy.name);
            setText(policy.text);
        }
    }, [policy]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await updatePolicy(policy.id, { name, text });
            onPolicyUpdated();
            onClose();
        } catch (error) {
            console.error('Error updating policy:', error);
        }
    };

    if (!policy) {
        return null;
    }

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Edit Policy</h2>
                    <button className="modal-close" onClick={onClose}>X</button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input
                            type="text"
                            id="name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                            placeholder='Name'
                        />
                    </div>
                    <div className="form-group">
                        <textarea
                            className="policy-text-full"
                            id="text"
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                            required
                            placeholder='Text'
                        />
                    </div>
                    <div className="actions-centered">
                        <button type="submit" className="submit-button text-button">Save Changes</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditPolicyModal;